export enum ScenarioStep {
  SIMULATION_INPUT = 'SIMULATION_INPUT',
  PASSING_PROSPECT = 'PASSING_PROSPECT',
  SUMMARY = 'SUMMARY',
}
